import FindAgentBlock from '../components/FindAgentBlock';

import React, { useRef } from 'react'

import useScrollSpy from 'react-use-scrollspy';
import AnchorLink from 'react-anchor-link-smooth-scroll';
import '../assets/styles/pages/_info-page.scss'

export const PrivacyPolicy = () => {
  const sectionRefs = [
      useRef(null),
      useRef(null),
      useRef(null),
      useRef(null),
      useRef(null),
      useRef(null),
  ];

  const activeSection = useScrollSpy({
    sectionElementRefs: sectionRefs,
    offsetPx: 0
  });

  const sideMenuItems = [
    { id: 1, text: 'Notice of Privacy Policy', url: '#anchor1' },
    { id: 2, text: 'What Information Do We Collect', url: '#anchor2' },
    { id: 3, text: 'How Do We Use Information', url: '#anchor3' },
    { id: 4, text: 'Changes to This Privacy Policy Statement', url: '#anchor4' },
    { id: 5, text: 'Reporting Information', url: '#anchor5' },
    { id: 6, text: 'Contractual Partners', url: '#anchor6' }
  ]

  const cards = [
    {
      id: 1,
      anchor: 'anchor1',
      mainTitle: 'Notice of Privacy Policy',
      content: [
        {
          type: 'paragraph',
          value: 'Your privacy is of utmost importance to us and it is our responsibility to inform you of how we gather the information and how we use that information. You will receive notice of our privacy policy the first time that we do business with you and every year thereafter.'
        },
        {
          type: 'list',
          list: [
              'We do share information among our group companies including name, address, and transaction experience.',
              'We do not sell customer information to non-affiliated parties.',
              'We do not provide customer information to outside parties who may use this information for their own purposes.',
              'We maintain physical, electronic, and procedural safeguards to protect your nonpublic personal information.',
              'We do not share any medical or health information among our family of companies or with third parties except to process transactions or to provide services you have requested or initiated.',
              'We do not disclose any nonpublic personal information about our customers or former customers to anyone, except as permitted by law.'
          ],
        },
      ]
    },
    {
      id: 2,
      anchor: 'anchor2',
      mainTitle: 'What Information Do We Collect',
      content: [
        {
          type: 'paragraph',
          value: 'The information that we collect from you and about you is obtained so that we may service your insurance needs and provide you with the insurance coverage that you require.'
        },
        {
          type: 'list',
          list: [
            'You provide to us on your application for insurance your address, telephone number, occupation, prior insurance carrier, and mortgage information.',
            'We collect prior claims history from a third party.',
            'We collect information on your credit history from a third party.',
            'We collect information on driving records from a third party.',
            'We collect information on your medical records in case of a bodily injury claim.',
            'Your transactions provide payment history, underwriting, and claims information.'
          ],
        },
        {
          type: 'paragraph',
          value: 'This information is only provided to our employees, agents or contractual partners who are directly involved in the business activity (e.g., underwriting, claims, accounting, reinsurance) in which they are involved in.'
        },
      ]
    },
    {
      id: 3,
      anchor: 'anchor3',
      mainTitle: 'How Do We Use Information',
      content: [
        {
          type: 'list',
          list: [
            'We use this information to underwrite your policy, process your claims, and ensure proper billing addresses for you or your mortgage in service to you as valued members of the RVOS Insurance Group.',
            'We disclose nonpublic personal information with a third party that performs claims services on our behalf. The information shared is information that is relevant to perform their services.',
            'Your personal information is shared within the RVOS Insurance Group of Companies in order for us to provide all of your insurance needs.',
            'We may also disclose nonpublic personal information about you to non-affiliated third parties as applicable as permitted by law.',
          ],
        },
      ]
    },
    {
      id: 4,
      anchor: 'anchor4',
      mainTitle: 'Changes to This Privacy Policy Statement',
      content: [
        {
          type: 'paragraph',
          value: 'We reserve the right to amend, change, modify, or supplement this Privacy Policy at any time. If we make material amendments, changes, modifications, or supplements to this Privacy Policy, we will provide our current customers with a revised notice evidencing such action.'
        },
      ]
    },
    {
      id: 5,
      anchor: 'anchor5',
      mainTitle: 'Reporting Information',
      content: [
        {
          type: 'paragraph',
          value: 'If you have any questions regarding any of the personal information that the RVOS Insurance Group has in its files, you may submit a request in writing identifying the policy (s) in question and what information you would like verified. If you have any questions about privacy, please contact us in writing at RVOS Farm Mutual Insurance Company, P.O. Box 6106, Temple, Texas 76503. Within 30 days we will respond and a nominal fee will be charged if copies are required. If you believe any information we have about you or your relationship with us is incorrect, please notify us at once. We will take prompt action in making the appropriate corrections.'
        },
      ]
    },
    {
      id: 6,
      anchor: 'anchor6',
      mainTitle: 'Contractual Partners',
      content: [
        {
          type: 'paragraph',
          value: 'RVOS may allow the following entities access to your confidential information for business reasons: R+V Versicherung AG'
        },
        {
          type: 'paragraph',
          value: `With regard to the processing of your Personal Data as defined by the European General Data Protection Regulation (GDPR) by our European reinsurers, please find further information to the respective reinsurer in accordance with Art. 14 GDPR at <a href="${process.env.REACT_APP_GDPR_URI}" target="_blank">http://www.gdpr.ruv.de</a>.`
        },
        {
          type: 'paragraph',
          value: 'Revised and updated January 2019.'
        },
      ]
    }
  ];

  const getList = (item) => {
    return (
        <ul>
          {item.list.map(li => {
            return (
                <li dangerouslySetInnerHTML={{__html: li}}/>
            )
          })}
        </ul>
    )
  }

  const toggleExceptionCardOpen = (e) => {
    e.target.parentNode.classList.toggle('open');
  }

  const toggleOpen = (e) => {
    e.target.closest('.main-card').classList.toggle('open');
  }

  return (
      <>
        <div className="info-page privacy-policy">
          <div className="header-block">
            <div className="main-title">PRIVACY POLICY</div>
          </div>
          <div className="main-block">
            <aside>
              <ul>
                {
                  sideMenuItems.map((item, index) => {
                    return <li key={item.id}>
                      <AnchorLink
                          className={activeSection === index ? 'active' : ''}
                          href={item.url}
                          offset={-20}
                      >
                        {item.text}
                      </AnchorLink>
                    </li>
                  })
                }
              </ul>
            </aside>
            <main>
              <div className="main-list">
                <div className="card-exception">
                  <div className="card-exception__title" onClick={(e) => toggleExceptionCardOpen(e)}>RVOS Insurance Group of Companies</div>
                  <ul className="card-exception__list">
                    <li>RVOS Farm Mutual Insurance Company</li>
                    <li>Priority One Insurance Company</li>
                    <li>RVOS General Agency, Inc.</li>
                  </ul>
                </div>
                {
                  cards.map((item, index) => {
                    return (
                        <div className="main-card" key={item.id} >
                          <div className="main-card__ref" id={item.anchor} ref={sectionRefs[index]}/>
                          <div className="title-line" onClick={(e) => toggleOpen(e)}>
                            <div className="title-main">{item.mainTitle}</div>
                          </div>
                          <div className="main-card__content">
                            {item.content.map(contentItem => {
                              if (contentItem.type === 'paragraph') {
                                return (
                                    <p dangerouslySetInnerHTML={{__html: contentItem.value}}/>
                                )
                              }
                              if (contentItem.type === 'list') {
                                return getList(contentItem);
                              }
                            })}
                          </div>
                        </div>
                    )
                  })
                }
              </div>
            </main>
          </div>
          <FindAgentBlock />
        </div>
      </>
  );
}
